import { render, staticRenderFns } from "./brand-ex-module.vue?vue&type=template&id=b9665fbe&scoped=true"
import script from "./brand-ex-module.vue?vue&type=script&lang=js"
export * from "./brand-ex-module.vue?vue&type=script&lang=js"
import style0 from "./brand-ex-module.vue?vue&type=style&index=0&id=b9665fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9665fbe",
  null
  
)

export default component.exports